import {ApplicationRef, inject} from '@angular/core'
import {Socket} from 'ngx-socket-io'
import {environment} from '@cart/src/environments/environment'

export class UveSocket extends Socket {
  constructor() {
    const appRef = inject(ApplicationRef)
    super(
      {
        url: environment.chatAppUrl,
        options: {
          autoConnect: true,
          transports: ['websocket'],
        },
      },
      appRef
    )
  }

  sendConnect() {
    if (this.ioSocket.connected) {
      return
    } else {
      this.ioSocket.connect()
    }
  }

  sendDisconnect() {
    this.ioSocket.disconnect()
  }
}
